import React from 'react';
import styled from 'styled-components';
import { SubCategoryItem, SubCategoryItemProps } from '../subCategoryItem';
import { theme } from '../../theme';
import { Heading } from '../typography';

const OuterContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledHeading = styled(Heading)`
  font-size: 22px;
  line-height: 26px;
  margin-bottom: ${theme.spacings[4].px};
  color: ${theme.colors.tints.graysRed._2};
`;

const CategoryContainer = styled.section`
  display: flex;
  flex-wrap: nowrap;
  gap: ${theme.spacings[5].rem};
  overflow-x: auto;

  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  &::-webkit-scrollbar {
    display: none;
  }
`;

export type CategoryPanelProps = {
  title: string;
  categoryItemsCollection: {
    items: SubCategoryItemProps[];
  };
};

export const CategoryPanel: React.FC<CategoryPanelProps> = ({
  title,
  categoryItemsCollection,
}) => {
  return (
    <OuterContainer>
      <StyledHeading size={5}>{title}</StyledHeading>
      <CategoryContainer>
        {categoryItemsCollection.items.map((item: SubCategoryItemProps) => (
          <SubCategoryItem key={item.label} {...item} />
        ))}
      </CategoryContainer>
    </OuterContainer>
  );
};
